const removeKeyDeduplicationSuffix = (key: string): string => {
  const match = key.match(/^(.*)_\d+$/);
  return match ? match[1] : key;
};

/**
 * Ensure that the key is unique among the existing keys.
 */
export const ensureUniqueKey = (existingKeys: string[], key: string) => {
  key = removeKeyDeduplicationSuffix(key);
  let result = key;
  let iteration = 0;

  while (existingKeys.includes(result) && iteration < 1000) {
    result = `${key}_${iteration}`;
    iteration += 1;
  }

  return result;
};

/**
 * Change the key argument so it does not conflict with existing keys in the fields.
 */
export const ensureUniqueFieldKey = (fields: { key: string }[], key: string) =>
  ensureUniqueKey(
    fields.map((field) => field.key),
    key,
  );
